import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Icon,
  Text,
  Box,
} from "@chakra-ui/react";
import { MdElectricCar } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import useAxios from "axios-hooks";
import { useRecoilState, useRecoilValue } from "recoil";

import { createConnectorDrawerState } from "atoms/createConnectorDrawerState";
import CreateConnectorDrawer from "../components/CreateConnectorDrawer";
import Connectors from "../tab_panels/Connectors";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";
import { loggedInUserState } from "atoms/loggedInUserState";
import { accessLevels } from "utils/accessLevels";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import { onlyAdmins } from "utils/accessLevels";

const ConnectorTabs = ({ chargePointId, chargePointCode }) => {
  const [drawerState, setDrawerState] = useRecoilState(
    createConnectorDrawerState,
  );
  const loggedInUser = useRecoilValue(loggedInUserState);
  const role = loggedInUser?.role;
  const canEdit = accessLevels[role]?.accessLevel <= 2;
  const [connectors, setConnectors] = useState([]);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [{ loading }, execute] = useAxios(
    {
      method: "GET",
      url: `/api/evses/forStation/${chargePointId}`,
    },
    { manual: true },
  );

  const getConnectors = async () => {
    try {
      const response = await execute();
      setConnectors(response.data.data);
    } catch (error) {
      logger.log(error);
    } finally {
      setInitialLoaded(true);
    }
  };

  const refreshHandler = async () => {
    setDrawerState(null);
    await getConnectors();
  };

  useEffect(() => {
    getConnectors();
  }, []);
  return (
    <Tabs isLazy variant="unstyled">
      <Flex
        flexDirection={{ base: "column", sm: "row" }}
        alignItems={{ base: "stretch", sm: "start" }}
        justifyContent="space-between"
        gap={{ base: 3, sm: 0 }}
      >
        <Box
          bg="rgba(255, 255, 255, 0.6)"
          backdropFilter="blur(12px)"
          borderRadius="xl"
          border="1px solid rgba(245, 125, 54, 0.15)"
          px={1}
          py={2}
          position="relative"
          overflow="hidden"
          overflowX={{ base: "auto", sm: "hidden" }}
          w={{ base: "100%", sm: "auto" }}
          _before={{
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "100%",
            zIndex: 0,
            pointerEvents: "none",
          }}
        >
          <TabList flexWrap={{ base: "nowrap", sm: "wrap" }}>
            <Tab
              borderRadius="lg"
              px={{ base: 3, md: 4 }}
              py={2}
              fontWeight="500"
              color="gray.600"
              position="relative"
              zIndex="1"
              minW="fit-content"
              whiteSpace="nowrap"
              _selected={{
                bg: "rgba(245, 125, 54, 0.15)",
                color: "#f57d36",
                fontWeight: "600",
                boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
              }}
              _hover={{
                bg: "rgba(245, 125, 54, 0.08)",
                color: "#f57d36",
              }}
            >
              <Flex align="center" gap={{ base: 1.5, md: 2 }}>
                <Icon as={MdElectricCar} boxSize={{ base: 3.5, md: 4 }} />
                <Text fontSize={{ base: "sm", md: "md" }}>Connectors</Text>
              </Flex>
            </Tab>
          </TabList>
        </Box>
        {connectors.length > 0 && (
          <RoleBasedRender roles={onlyAdmins}>
            <Button
              leftIcon={<FaPlus />}
              colorScheme="whatsapp"
              variant="solid"
              onClick={() => setDrawerState({ isOpen: true })}
              disabled={!canEdit}
              w={{ base: "100%", sm: "auto" }}
              fontSize={{ base: "sm", md: "md" }}
            >
              Add Connector
            </Button>
          </RoleBasedRender>
        )}
      </Flex>
      {drawerState?.isOpen && (
        <CreateConnectorDrawer
          chargePointCode={chargePointCode}
          chargePointId={chargePointId}
          refreshHandler={getConnectors}
          update={refreshHandler}
        />
      )}

      <TabPanels>
        {!initialLoaded && loading ? (
          <LoadingSpinner />
        ) : (
          <TabPanel px={{ base: 0, md: 2 }}>
            {connectors.length > 0 ? (
              <Connectors
                data={connectors}
                refreshHandler={getConnectors}
              />
            ) : (
              <Flex
                padding="18"
                flexDirection="row"
                alignItems="center"
                justifyContent="center"
              >
                <RoleBasedRender roles={onlyAdmins}>
                  <Button
                    leftIcon={<FaPlus />}
                    colorScheme="whatsapp"
                    variant="solid"
                    onClick={() => setDrawerState({ isOpen: true })}
                    disabled={!canEdit}
                  >
                    Add Connector
                  </Button>
                </RoleBasedRender>
              </Flex>
            )}
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
};

export default ConnectorTabs;
